// Types mirroring app/services/global_search/models.py on the API side.
// Keep in sync with SearchEntityType, ResultItem discriminated union, and
// GlobalSearchResponseData in compass-api.

export enum SearchEntityType {
  COMPANY = "COMPANY",
  FUND = "FUND",
  MANAGER = "MANAGER",
  ENGAGEMENT = "ENGAGEMENT",
  INTERACTION = "INTERACTION",
  VOTING = "VOTING",
  LINKAGE = "LINKAGE",
  TASK = "TASK",
}

export interface BaseResultItem {
  id: string;
  label: string;
  subtitle: string;
  image_url: string | null;
  matched_field: string | null;
}

export interface CompanyResultItem extends BaseResultItem {
  type: SearchEntityType.COMPANY;
  sector: string | null;
  country: string | null;
}

export interface FundResultItem extends BaseResultItem {
  type: SearchEntityType.FUND;
  manager_id: string | null;
  manager_name: string | null;
  manager_image: string | null;
  is_index: boolean;
}

export interface ManagerResultItem extends BaseResultItem {
  type: SearchEntityType.MANAGER;
  email: string | null;
  is_fund_owner: boolean;
}

export interface EngagementResultItem extends BaseResultItem {
  type: SearchEntityType.ENGAGEMENT;
  company_id: string | null;
  company_name: string | null;
  meta_theme: string | null;
  theme: string | null;
  engagement_start: string | null;
  manager_id: string | null;
  manager_name: string | null;
  manager_image: string | null;
}

export interface InteractionResultItem extends BaseResultItem {
  type: SearchEntityType.INTERACTION;
  engagement_record_id: string;
  engagement_name: string | null;
  engagement_milestone: string | null;
  momentum: string | null;
  interaction_date: string | null;
  company_id: string | null;
  company_name: string | null;
  meta_theme: string | null;
  manager_id: string | null;
  manager_name: string | null;
  manager_image: string | null;
}

export interface VotingResultItem extends BaseResultItem {
  type: SearchEntityType.VOTING;
  company_id: string | null;
  company_name: string | null;
  proposal_date: string | null;
  vote: string | null;
  manager_id: string | null;
  manager_name: string | null;
  manager_image: string | null;
}

export interface LinkageResultItem extends BaseResultItem {
  type: SearchEntityType.LINKAGE;
  company_id: string | null;
  company_name: string | null;
  linkage_type: string;
  confidence_score: number;
}

export interface TaskResultItem extends BaseResultItem {
  type: SearchEntityType.TASK;
  status: string | null;
  priority: string | null;
  assigned_to: string | null;
  due_date: string | null;
  is_flag: boolean;
}

export type SearchResultItem =
  | CompanyResultItem
  | FundResultItem
  | ManagerResultItem
  | EngagementResultItem
  | InteractionResultItem
  | VotingResultItem
  | LinkageResultItem
  | TaskResultItem;

export interface GlobalSearchDiagnostics {
  counts: Partial<Record<SearchEntityType, number>>;
  failures: Partial<Record<SearchEntityType, string>>;
}

export interface GlobalSearchResponseData {
  results: SearchResultItem[];
  total: number;
  diagnostics: GlobalSearchDiagnostics;
}

export interface GlobalSearchRequest {
  query: string;
  limit?: number;
  types?: SearchEntityType[];
}
